// Copyright (c) Docugami, Inc. All rights reserved.

import { IDocumentCommand } from "components/file_management/DocumentCommand";
import { FilePicker } from "components/file_management/presentation/FileUploader";
import { useMemo } from "react";

export function useDocumentUploadCommand(filePicker: FilePicker, onComplete: (error?: any) => void): IDocumentCommand[] {
    return useMemo(() => {
        const uploadFiles: IDocumentCommand = {
            id: "UploadFiles",
            label: "Files",
            isActive: false,
            isEnabled: true,
            visual: null,
            execute: filePicker.showFilePicker,
            set: "Upload Docs"
        };

        const uploadFolders: IDocumentCommand = {
            id: "UploadFolders",
            label: "Folders",
            isActive: false,
            isEnabled: true,
            visual: null,
            execute: filePicker.showFolderPicker,
            set: "Upload Docs"
        };

        return [uploadFiles, uploadFolders]
    }, [filePicker]);
}
